
import {newDateFromString} from "@/utils/utils.js";

export default {
    methods: {
        fullFormatDate(date) {
            const locales = {
                benl : "nl-BE",
                nl : "nl-BE",
                fr : "fr-BE",
                en : "en-EN",
                de : "de-DE"
            };

            const options = {weekday: "long", year: "numeric", month: "long", day: "numeric"};
            const locale = locales[this.$i18n.locale];
        
            return newDateFromString(date).toLocaleDateString(locale, options);
        }
    }
};